import classNames from 'classnames';
import React from 'react';
import { AssessmentListItemType } from '@redux/tasks/tasksTypes';
import { CircledCustomIcon, WaveformIcon } from 'components/Icons';
import { Text } from 'components/Typography';
import { AssessmentMenuOption } from 'containers/Tasks/components/AssessmentArea/AssessmentMenuOption/AssessmentMenuOption';
import style from './MessageReviewArea.scss';

type TaskReviewAreaProps = {
  message: string;
  assessment?: AssessmentListItemType | null;
  containerStyle?: string;
};

export const MessageReviewArea: React.FC<TaskReviewAreaProps> = ({ message, assessment = null, containerStyle }) => {
  return (
    <div className={classNames(style.content, containerStyle)}>
      <CircledCustomIcon icon={WaveformIcon} width={16} height={16} containerStyle={style.iconWrapper} />
      <div className={style.textWrapper}>
        <Text variant="md" weight={600}>
          Message summary
        </Text>
        <Text variant="md">{message}</Text>
      </div>
      {assessment ? <AssessmentMenuOption option={assessment} containerStyle={style.assessment} /> : null}
    </div>
  );
};
